const LIMIT = 100
export const printCount = (count: number, limit: number = LIMIT): string =>
  `${count >= limit ? `${limit}+` : count}`
export const limitCount = (count: number, limit: number = LIMIT): number => Math.min(count, limit)
export function nth(num: number): string {
  /* eslint-disable @typescript-eslint/no-magic-numbers */
  const j = num % 10
  const k = num % 100

  if (j === 1 && k !== 11) {
    return `${num}st`
  }

  if (j === 2 && k !== 12) {
    return `${num}nd`
  }

  if (j === 3 && k !== 13) {
    return `${num}rd`
  }

  return `${num}th`
  /* eslint-enable @typescript-eslint/no-magic-numbers */
}
